import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import { Clock, ChevronRight, X } from "lucide-react"
import { clearSearchHistory, getSearchHistory } from "../../utils/localstorage/search"
import { useDispatch } from "react-redux"
import { setSelectedAviaTerminals } from "../../../../../app/reducers/book/aviaSearchSlice"

const joinCities = (terminals = []) =>
  terminals
    .map((t) => t.city || t.name)
    .filter(Boolean)
    .filter((v, i, arr) => arr.indexOf(v) === i)
    .join(", ") || "—"

const RecentSearchesV2 = ({ fetchTerminals }) => {
  const dispatch = useDispatch()
  const { t } = useTranslation()

  // states
  const [recentSearches, setRecentSearches] = useState([])

  useEffect(() => {
    setRecentSearches(getSearchHistory())
  }, [])

  if (!recentSearches || recentSearches.length === 0) return null

  const handleClick = async (item) => {
    const { arrivalIds, departureIds } = item

    try {
      await fetchTerminals({ terminalId: departureIds })
      dispatch(
        setSelectedAviaTerminals({
          departureIds,
          arrivalIds,
        })
      )
    } catch (error) {
      console.log("get terminals err: ", error)
    }
  }

  const onClear = () => {
    const cleared = clearSearchHistory()
    setRecentSearches(cleared)
  }

  return (
    <div className="mb-3">
      {/* Header */}
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center gap-2">
          <Clock className="w-4 h-4 text-text-secondary" />
          <h3 className="text-sm font-medium text-dark-gray">{t("admin.recent_searches")}</h3>
        </div>
        <button
          onClick={onClear}
          className="flex items-center gap-1 text-xs text-text-secondary hover:text-text-main transition-colors px-2 py-1 rounded hover:bg-gray-50"
          title={t("admin.clear_history")}
        >
          <X className="w-3 h-3" />
          <span>{t("admin.clear")}</span>
        </button>
      </div>

      <ul className="space-y-0.5">
        {recentSearches.map((item, index) => {
          const fromLabel = joinCities(item.from)
          const toLabel = joinCities(item.to)

          return (
            <li key={item.id ?? index}>
              <button
                type="button"
                onClick={() => handleClick(item)}
                className="w-full flex items-center gap-2 px-2 py-2.5 rounded-md hover:bg-gray-50 transition-colors text-left group"
              >
                <span className="flex-shrink-0 w-8 h-8 flex items-center justify-center text-red-500">
                  <Clock size={20} strokeWidth={1.8} />
                </span>

                <span className="flex-1 min-w-0">
                  <span className="block text-sm font-medium text-text-main truncate">
                    {fromLabel} <span className="inline-block">⇄</span> {toLabel}
                  </span>
                  {(item?.fromDate || item?.toDate) && (
                    <span className="block text-xs text-gray-400 mt-0.5">
                      {item?.fromDate}
                      {item?.toDate ? ` - ${item?.toDate}` : ""}
                    </span>
                  )}
                </span>

                <ChevronRight
                  size={16}
                  strokeWidth={1.8}
                  className="flex-shrink-0 text-gray-400 group-hover:text-gray-600 transition-colors"
                />
              </button>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default RecentSearchesV2
